export default "__VITE_ASSET__00bac2e5__"